<template>
    <div class="users-style" v-if="agents.length > 0">
       
        
        <a v-if="agent_name" class="nav-link dropdown-toggle text-white rounded py-0 mt-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  href="">
            <span class="comapny-left-block d-inline-block align-middle">
                <span class="menu-company-img"><b-avatar variant="info" v-bind:src="$api_url+'/images/agent/'+agent_logo" class="mr-0 rounded-0 agent-logo" size="36px"></b-avatar></span>
                <span class="menu-company-name text-uppercase">{{agent_name}}</span>
            </span>
        </a>        
        
        <a v-else class="nav-link dropdown-toggle no-data text-white rounded mt-0 py-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  href="">
            <span class="menu-company-img"><img v-bind:src="$api_url+'/images/no-company.jpg'" class="mr-0 rounded-0 agent-logo" width="36px"></span>
            <span class="company-not-selected">Select Agent</span><span class="arrow"></span>
        </a>
        
        <ul class="dropdown-menu dropdown-menu-leftt ">           
            <li class="nav-item" v-for='agent in agents'>
                <a v-if="agent.id == agent_id" class="nav-link active" :href="'#'" @click="companiesAgent(agent.id)"><b-avatar variant="info" v-bind:src="$api_url+'/images/agent/'+agent.logo" class="mr-0 rounded-0 agent-logo" size="30px"></b-avatar>{{agent.name}}</a>
                <a v-else class="nav-link " :href="'#'" @click="companiesAgent(agent.id)"><b-avatar variant="info" v-bind:src="$api_url+'/images/agent/'+agent.logo" class="mr-0 rounded-0 agent-logo" size="30px"></b-avatar>{{agent.name}}</a>
            </li>
            <!--<li class="nav-item">
                <a class="nav-link" :href="$api_url+'/agent/'">All Agents</a>
            </li>-->
        </ul>
    </div>
</template>
<script>
    export default{
        
        mounted() {
            
        },
        data(){            
            
            return {               
                
                agents: [],
                agent_logo: null,                
                agent_name:null,
                agent_id:null,
                
            }
        },
        methods:{
            getAgentData: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/agent/list' , {
                    params: {
                        
                    }
                }).then(function(response){
                    this.agents = response.data;
                    this.getCurrentAgent();
                }.bind(this));
            },
            getCurrentAgent: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/agent/publicinfo' , {
                    params: {
                        
                    }
                }).then(function(response){         
                    //console.log(response.data);           
                    this.agent_logo = response.data.logo;
                    this.agent_name = response.data.name;
                    this.agent_id = response.data.id;
                }.bind(this));
            },
            companiesAgent:function(x)
            {
                if(!this.checkNet()) return false;
                let formData = new FormData();
                formData.append('agent_id', x);
                axios.post(this.$api_url+'/agent/setagent', formData)
                                .then(function (response) 
                                {                                                                    
                                    window.location.href = this.$api_url+'/company';
                                    
                                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },
            

        },
        created: function(){
            this.getAgentData();
        }
    }
</script>